import React, { useState, useEffect } from "react";
import LogoImage from "./img/tech.png"; // <-- import your local logo image

const Navbar = ({ sections }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    const handleScroll = () => {
      const scrollPos = window.scrollY + 100;
      for (const key in sections) {
        if (sections[key].current) {
          const sectionTop = sections[key].current.offsetTop;
          const sectionHeight = sections[key].current.offsetHeight;
          if (scrollPos >= sectionTop && scrollPos < sectionTop + sectionHeight) {
            setActiveSection(key);
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [sections]);

  const navStyle = {
    container: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0.5rem 2rem",
      backgroundColor: "transparent",
      color: "#8B4513",
      position: "sticky",
      top: 0,
      zIndex: 999,
      width: "100%",
      maxWidth: "100%",
      margin: "0 auto",
      boxSizing: "border-box",
      flexWrap: "wrap",
    },
    logo: {
      height: isMobile ? "35px" : "50px", // logo size adapts
      width: "auto",
      cursor: "pointer",
      flexShrink: 0,
    },
    menu: {
      display: "flex",
      gap: "1rem",
      listStyle: "none",
      width: isMobile ? "100%" : "auto",
      flexDirection: isMobile ? "column" : "row",
      backgroundColor: isMobile ? "rgba(134, 124, 124, 0.85)" : "transparent",
      position: isMobile ? "absolute" : "static",
      top: isMobile ? "60px" : "auto",
      left: 0,
      padding: isMobile ? "1rem 0" : 0,
      flexWrap: "wrap",
      justifyContent: isMobile ? "flex-start" : "flex-end",
      transition: "all 0.3s ease",
      overflow: "hidden",
    },
    menuItem: {
      position: "relative",
    },
    link: {
      color: "#000000ff",
      textDecoration: "none",
      padding: "0.5rem 1rem",
      display: "block",
      whiteSpace: "nowrap",
      transition: "color 0.3s, background-color 0.3s",
      cursor: "pointer",
      borderRadius: "4px",
    },
    linkActive: {
      backgroundColor: "#A0522D",
      color: "#fff",
    },
    hamburger: {
      display: isMobile ? "flex" : "none",
      flexDirection: "column",
      justifyContent: "space-between",
      width: "25px",
      height: "20px",
      cursor: "pointer",
      marginLeft: "auto",
      zIndex: 1001,
    },
    bar: {
      height: "3px",
      width: "100%",
      backgroundColor: "#8B4513",
      borderRadius: "2px",
      transition: "all 0.3s ease",
    },
  };

  const handleScrollTo = (key) => {
    if (sections[key]?.current) {
      sections[key].current.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/";
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <nav style={navStyle.container}>
      {/* Logo Image */}
      <img
        src={LogoImage}
        alt="Logo"
        style={navStyle.logo}
        onClick={() => handleScrollTo("home")} // clicking logo scrolls home
      />

      {/* Hamburger */}
      {isMobile && (
        <div
          style={navStyle.hamburger}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span
            style={{
              ...navStyle.bar,
              transform: isMobileMenuOpen
                ? "rotate(45deg) translate(5px, 5px)"
                : "rotate(0)",
            }}
          />
          <span
            style={{
              ...navStyle.bar,
              opacity: isMobileMenuOpen ? 0 : 1,
            }}
          />
          <span
            style={{
              ...navStyle.bar,
              transform: isMobileMenuOpen
                ? "rotate(-45deg) translate(5px, -5px)"
                : "rotate(0)",
            }}
          />
        </div>
      )}

      {/* Menu */}
      {(isMobile ? isMobileMenuOpen : true) && (
        <ul style={navStyle.menu}>
          {Object.keys(sections).map((key) => (
            <li key={key} style={navStyle.menuItem}>
              <div
                style={{
                  ...navStyle.link,
                  ...(activeSection === key ? navStyle.linkActive : {}),
                }}
                onClick={() => handleScrollTo(key)}
              >
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </div>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default Navbar;
